import { removeKeysFromObj as g } from "./object.js";
function l(a) {
  return new i(localStorage, a);
}
function S(a) {
  return new i(sessionStorage, a);
}
class i {
  LOCAL_STORAGE_KEY;
  // use '.' only to distinct version
  versionDelimiter = ".";
  storage;
  storageType;
  constructor(t, e) {
    this.LOCAL_STORAGE_KEY = e, this.storage = t, this.storageType = t === localStorage ? "local" : "session";
  }
  getFromStorage = (t) => {
    try {
      const e = this.storage.getItem(this.LOCAL_STORAGE_KEY);
      return e === null ? null : JSON.parse(e)[t];
    } catch (e) {
      return console.error(
        `getFromStorage, can't get data from ${this.storageType} storage: `,
        e.message
      ), null;
    }
  };
  saveToStorage = (t, e) => {
    try {
      const r = this.storage.getItem(this.LOCAL_STORAGE_KEY), s = r !== null ? JSON.parse(r) : {}, o = this.generateOlderKeys(t), n = g(s, o);
      return n[t] = e, this.storage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(n)), !0;
    } catch (r) {
      return console.error(
        `saveToStorage, can't save data to ${this.storageType} storage: `,
        r.message
      ), !1;
    }
  };
  removeUnitFromStorage = (t) => {
    try {
      const e = this.storage.getItem(this.LOCAL_STORAGE_KEY), r = e !== null ? JSON.parse(e) : {};
      delete r[t], this.storage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(r));
    } catch (e) {
      console.error(
        `removeUnitFromStorage, can't remove data from ${this.storageType} storage: `,
        e.message
      );
    }
  };
  cleanObsoleteStorage = () => {
    try {
      const t = this.generateOlderKeys(this.LOCAL_STORAGE_KEY);
      for (const e of t)
        this.storage.removeItem(e);
    } catch (t) {
      console.error(
        `cleanObsoleteStorage, can't remove obsolete data from ${this.storageType} storage: `,
        t.message
      );
    }
  };
  generateOlderKeys = (t) => {
    const e = [], r = t.split(this.versionDelimiter), s = Number(
      r.find((o) => o[0] === "v" && isFinite(Number(o.slice(1))))?.slice(1)
    );
    for (let o = 1; o < s; o++)
      t.indexOf(`.v${s}.`) !== -1 && e.push(t.replace(`.v${s}.`, `.v${o}.`));
    return e;
  };
}
export {
  i as StorageManager,
  l as createLocalStorageManager,
  S as createSessionStorageManager
};
